import http from 'apis/config/http-service';
import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { UseQueryOptions, UseQueryResult } from 'react-query';
import type { InquiryBranchSummary } from './types';

// GET api/v1/restaurants/branches/:restaurantId — same endpoint the restaurants
// module uses (use-get-branch-list-api), but self-contained: that hook reads
// page/limit from URL params, which a modal must not depend on.
const endpoint = 'api/v1/restaurants/branches';

type TData = InquiryBranchSummary[];
type TError = AxiosError;
type TQueryKey = [string, number | undefined];
type Options = Omit<UseQueryOptions<TData, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;

export function useGetInquiryRestaurantBranchesApi(
  restaurantId?: number,
  options?: Options
): UseQueryResult<TData, TError> {
  const queryFn = async (): Promise<TData> => {
    const response = await http.get(`${endpoint}/${restaurantId}`, { params: { page: 1, limit: 100 } });
    return response.data?.data ?? response.data ?? [];
  };

  return useQueryWrapper([`${endpoint}/inquiry-send-order`, restaurantId], queryFn, {
    enabled: !!restaurantId,
    ...options,
  });
}
